export default "__VITE_ASSET__B6tfij4C__"